import { Pipe, PipeTransform } from "@angular/core";
import { LANGUAGE_MAPPINGS } from "../../../../app/common/constants/language-mappings.const";

@Pipe({
    name: 'languageCodeToText'
})
export class LanguageFormatPipe implements PipeTransform {
    constructor() { }
    transform(value: any, ...args: any[]) {
        let result;
        LANGUAGE_MAPPINGS.forEach(data => {
            if (data.langCode === value) {
                result = data.langInEng;
            }
        });
        if (result) {
            return result;
        }
        return value;
    }
}